import { AnimatePresence, motion } from 'motion/react';
import { useBroadcast } from './hooks/useBroadcast';
import { useEffect, useMemo } from 'react';

import { Video } from './components/Video/Video';

import leftVideo from './assets/videos/leftVideo.webm';
import rightVideo from './assets/videos/rightVideo.webm';

function App() {
  const { currentState } = useBroadcast();

  const videosSrc = [leftVideo, rightVideo];

  useEffect(() => {
    videosSrc.forEach((src) => {
      let media = document.createElement('video');
      media.preload = 'auto';
      media.src = src;
    });
  }, []);

  const currentSrcVideo = useMemo(() => {
    const workingState = ['S1', 'S2'];

    if (!currentState || !workingState.includes(currentState)) {
      return '';
    } else if (currentState === 'S1') {
      return leftVideo;
    } else if (currentState === 'S2') {
      return rightVideo;
    }
  }, [currentState]);

  return (
    <div className="app-wrapper">
      <AnimatePresence mode="wait">
        {currentSrcVideo && (
          <motion.div
            key={currentSrcVideo}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Video srcVideo={currentSrcVideo} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
